export class Beneficiary {
  id: number;
  fullName?: string;
  cnp?: string;
  city?: string;
  phoneNumber?: string;
  email?: string;
  isAgreed: boolean;
  kinship?: string;
  isDeleted: boolean;
}
